// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #000;
}

.hero-canvas {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 0;
}

.hero-scanlines {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: repeating-linear-gradient(
    0deg, transparent, transparent 2px,
    rgba(0,0,0,0.06) 2px, rgba(0,0,0,0.06) 4px
  );
  z-index: 1;
  pointer-events: none;
}

.hero-vignette {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.8) 100%);
  z-index: 2;
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 2rem;
  max-width: 900px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: #00ff88;
  margin-bottom: 2rem;
  padding: 0.4rem 1rem;
  border: 1px solid rgba(0,255,136,0.2);
  border-radius: 2px;
}

.hero-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  background: #00ff88;
  box-shadow: 0 0 8px #00ff88;
  animation: heroBlink 1.8s ease-in-out infinite;
}

@keyframes heroBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
}

.hero-title {
  font-size: clamp(4rem, 12vw, 10rem);
  font-weight: 900;
  letter-spacing: 0.05em;
  line-height: 0.95;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.hero-kro {
  color: #fff;
  display: inline-block;
}

.hero-maker {
  display: inline-block;
  color: transparent;
  -webkit-text-stroke: 2px #bf00ff;
  position: relative;
}

.hero-maker::after {
  content: 'Maker';
  position: absolute;
  top: 0; left: 0;
  color: transparent;
  -webkit-text-stroke: 2px #00ffff;
  animation: heroGlitch 4s infinite;
  clip-path: polygon(0 30%, 100% 30%, 100% 50%, 0 50%);
}

@keyframes heroGlitch {
  0%, 85%, 100% { transform: translate(0); opacity: 0; }
  87% { transform: translate(-4px, 2px); opacity: 0.7; }
  90% { transform: translate(4px, -2px); opacity: 0.7; }
  93% { transform: translate(0); opacity: 0; }
}

.hero-subtitle {
  font-size: clamp(0.9rem, 2vw, 1.2rem);
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.4);
  margin-bottom: 1.5rem;
}

.hero-desc {
  font-size: clamp(1rem, 1.8vw, 1.15rem);
  color: rgba(255,255,255,0.65);
  line-height: 1.8;
  margin-bottom: 3rem;
  font-weight: 300;
}

.hero-cta {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 4rem;
}

.btn-primary {
  background: #bf00ff;
  color: #fff;
  border: none;
  padding: 0.9rem 2.2rem;
  font-size: 0.9rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%);
  transition: all 0.3s;
  font-weight: 600;
}

.btn-primary:hover {
  background: #d400ff;
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(191,0,255,0.4);
}

.btn-secondary {
  background: transparent;
  color: rgba(255,255,255,0.8);
  border: 1px solid rgba(255,255,255,0.2);
  padding: 0.9rem 2.2rem;
  font-size: 0.9rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%);
  transition: all 0.3s;
}

.btn-secondary:hover {
  border-color: rgba(191,0,255,0.6);
  color: #bf00ff;
  transform: translateY(-2px);
}

.hero-scroll-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  animation: heroFloat 2.5s ease-in-out infinite;
}

@keyframes heroFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(8px); }
}

.scroll-line {
  width: 1px;
  height: 50px;
  background: linear-gradient(to bottom, #bf00ff, transparent);
}

.hero-scroll-indicator span {
  font-size: 0.65rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.3);
}

.hero-corners .corner {
  position: fixed;
  width: 30px; height: 30px;
  z-index: 5;
}
.corner.tl { top: 20px; left: 20px; border-top: 1px solid rgba(191,0,255,0.4); border-left: 1px solid rgba(191,0,255,0.4); }
.corner.tr { top: 20px; right: 20px; border-top: 1px solid rgba(191,0,255,0.4); border-right: 1px solid rgba(191,0,255,0.4); }
.corner.bl { bottom: 20px; left: 20px; border-bottom: 1px solid rgba(191,0,255,0.4); border-left: 1px solid rgba(191,0,255,0.4); }
.corner.br { bottom: 20px; right: 20px; border-bottom: 1px solid rgba(191,0,255,0.4); border-right: 1px solid rgba(191,0,255,0.4); }

@media (max-width: 768px) {
  .hero-cta { flex-direction: column; align-items: center; }
  .btn-primary, .btn-secondary { width: 100%; max-width: 280px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB;;;GAGC;EACD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,WAAW,EAAE,YAAY;EACzB,qFAAqF;EACrF,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM,EAAE,OAAO;EACf,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA;EACE,gBAAgB,uBAAuB,EAAE,UAAU,EAAE;EACrD,MAAM,+BAA+B,EAAE,YAAY,EAAE;EACrD,MAAM,+BAA+B,EAAE,YAAY,EAAE;EACrD,MAAM,uBAAuB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,qEAAqE;EACrE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,uCAAuC;EACvC,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,qEAAqE;EACrE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW,EAAE,YAAY;EACzB,UAAU;AACZ;AACA,aAAa,SAAS,EAAE,UAAU,EAAE,yCAAyC,EAAE,0CAA0C,EAAE;AAC3H,aAAa,SAAS,EAAE,WAAW,EAAE,yCAAyC,EAAE,2CAA2C,EAAE;AAC7H,aAAa,YAAY,EAAE,UAAU,EAAE,4CAA4C,EAAE,0CAA0C,EAAE;AACjI,aAAa,YAAY,EAAE,WAAW,EAAE,4CAA4C,EAAE,2CAA2C,EAAE;;AAEnI;EACE,YAAY,sBAAsB,EAAE,mBAAmB,EAAE;EACzD,+BAA+B,WAAW,EAAE,gBAAgB,EAAE;AAChE","sourcesContent":[".hero {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #000;\n}\n\n.hero-canvas {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  z-index: 0;\n}\n\n.hero-scanlines {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background: repeating-linear-gradient(\n    0deg, transparent, transparent 2px,\n    rgba(0,0,0,0.06) 2px, rgba(0,0,0,0.06) 4px\n  );\n  z-index: 1;\n  pointer-events: none;\n}\n\n.hero-vignette {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  background: radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.8) 100%);\n  z-index: 2;\n  pointer-events: none;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 10;\n  text-align: center;\n  padding: 2rem;\n  max-width: 900px;\n}\n\n.hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.75rem;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  color: #00ff88;\n  margin-bottom: 2rem;\n  padding: 0.4rem 1rem;\n  border: 1px solid rgba(0,255,136,0.2);\n  border-radius: 2px;\n}\n\n.hero-dot {\n  width: 6px; height: 6px;\n  border-radius: 50%;\n  background: #00ff88;\n  box-shadow: 0 0 8px #00ff88;\n  animation: heroBlink 1.8s ease-in-out infinite;\n}\n\n@keyframes heroBlink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.2; }\n}\n\n.hero-title {\n  font-size: clamp(4rem, 12vw, 10rem);\n  font-weight: 900;\n  letter-spacing: 0.05em;\n  line-height: 0.95;\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n}\n\n.hero-kro {\n  color: #fff;\n  display: inline-block;\n}\n\n.hero-maker {\n  display: inline-block;\n  color: transparent;\n  -webkit-text-stroke: 2px #bf00ff;\n  position: relative;\n}\n\n.hero-maker::after {\n  content: 'Maker';\n  position: absolute;\n  top: 0; left: 0;\n  color: transparent;\n  -webkit-text-stroke: 2px #00ffff;\n  animation: heroGlitch 4s infinite;\n  clip-path: polygon(0 30%, 100% 30%, 100% 50%, 0 50%);\n}\n\n@keyframes heroGlitch {\n  0%, 85%, 100% { transform: translate(0); opacity: 0; }\n  87% { transform: translate(-4px, 2px); opacity: 0.7; }\n  90% { transform: translate(4px, -2px); opacity: 0.7; }\n  93% { transform: translate(0); opacity: 0; }\n}\n\n.hero-subtitle {\n  font-size: clamp(0.9rem, 2vw, 1.2rem);\n  letter-spacing: 0.4em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.4);\n  margin-bottom: 1.5rem;\n}\n\n.hero-desc {\n  font-size: clamp(1rem, 1.8vw, 1.15rem);\n  color: rgba(255,255,255,0.65);\n  line-height: 1.8;\n  margin-bottom: 3rem;\n  font-weight: 300;\n}\n\n.hero-cta {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: 4rem;\n}\n\n.btn-primary {\n  background: #bf00ff;\n  color: #fff;\n  border: none;\n  padding: 0.9rem 2.2rem;\n  font-size: 0.9rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  cursor: pointer;\n  clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%);\n  transition: all 0.3s;\n  font-weight: 600;\n}\n\n.btn-primary:hover {\n  background: #d400ff;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(191,0,255,0.4);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: rgba(255,255,255,0.8);\n  border: 1px solid rgba(255,255,255,0.2);\n  padding: 0.9rem 2.2rem;\n  font-size: 0.9rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  cursor: pointer;\n  clip-path: polygon(12px 0%, 100% 0%, calc(100% - 12px) 100%, 0% 100%);\n  transition: all 0.3s;\n}\n\n.btn-secondary:hover {\n  border-color: rgba(191,0,255,0.6);\n  color: #bf00ff;\n  transform: translateY(-2px);\n}\n\n.hero-scroll-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  animation: heroFloat 2.5s ease-in-out infinite;\n}\n\n@keyframes heroFloat {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(8px); }\n}\n\n.scroll-line {\n  width: 1px;\n  height: 50px;\n  background: linear-gradient(to bottom, #bf00ff, transparent);\n}\n\n.hero-scroll-indicator span {\n  font-size: 0.65rem;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.3);\n}\n\n.hero-corners .corner {\n  position: fixed;\n  width: 30px; height: 30px;\n  z-index: 5;\n}\n.corner.tl { top: 20px; left: 20px; border-top: 1px solid rgba(191,0,255,0.4); border-left: 1px solid rgba(191,0,255,0.4); }\n.corner.tr { top: 20px; right: 20px; border-top: 1px solid rgba(191,0,255,0.4); border-right: 1px solid rgba(191,0,255,0.4); }\n.corner.bl { bottom: 20px; left: 20px; border-bottom: 1px solid rgba(191,0,255,0.4); border-left: 1px solid rgba(191,0,255,0.4); }\n.corner.br { bottom: 20px; right: 20px; border-bottom: 1px solid rgba(191,0,255,0.4); border-right: 1px solid rgba(191,0,255,0.4); }\n\n@media (max-width: 768px) {\n  .hero-cta { flex-direction: column; align-items: center; }\n  .btn-primary, .btn-secondary { width: 100%; max-width: 280px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
